import * as React from 'react';
import { connect } from 'react-redux';
import TagsList from 'src/components/Tags/list';

class Container extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    const { tags } = this.props;

    return (
      <TagsList
        tags={tags}
      />
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    tags: state.tags,
  };
};

export default connect(mapStateToProps)(Container);



// WEBPACK FOOTER //
// ./src/containers/Tags/index.tsx